import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="stepper-step"
export default class extends Controller {
  static targets = ['label'];

  connect() {
    this.labelTarget.addEventListener("click", this.handleLabelClick.bind(this));
  }

  disconnect() {
    this.labelTarget.removeEventListener("click", this.handleLabelClick.bind(this));
  }

  handleLabelClick() {
    let content = this.labelTarget.parentElement.querySelector(".content");
    let chevron = this.labelTarget.parentElement.querySelector(".chevron");

    if (this.labelTarget.dataset.expandable === "true") {
      if (content.classList.contains("h-0")) {
        content.classList.remove("h-0", "overflow-hidden");
        content.classList.add("h-full", "p-8", "border-t-2");
        chevron.classList.add("rotate-90");
      } else {
        content.classList.remove("h-full", "p-8", "border-t-2");
        content.classList.add("h-0", "overflow-hidden");
        chevron.classList.remove("rotate-90");
      }
    }
  }
}
